import { UpdatePasswordModal } from '../../../design-system';
import { DashboardFormWrapper } from '../../dashboard';
import { AccountPage, AccountHeader, AccountForm } from './AccountComponents';
import { RoleGuard } from '../../../routes';

export const Account = () => {
  return (
    <RoleGuard roles={['TRADER']} isMobile negative>
      <AccountPage>
        <AccountHeader />
        <DashboardFormWrapper flow={'row'}>
          <AccountForm company={null} />
        </DashboardFormWrapper>
      </AccountPage>
      <UpdatePasswordModal />
    </RoleGuard>
  );
};
